<template>
    <div class="p-col-12">
			<div class="card">
                <h5>Evidencias</h5>
                <Button @click="getAll()" class="p-button-success">Refresh</Button>
               
                <DataTable :value="items" scrollHeight="400px" 
                            :loading="loading2" scrollDirection="both" class="p-mt-3" >
                            <Column field="id" header="Id" :style="{width:'300px'}"></Column>
                            <Column field="line" header="Nro Linea" ></Column>    
                            <Column field="evidenciaId" header="Evidencia" ></Column>                                            
                        </DataTable>
			</div>
	</div>
</template>  

<script>

import { apiGet } from '../../helpers/rest-api'

export default {

   data () {
       return { procesoId :  this.$router.currentRoute.value.params.id, items : []}
   },
   mounted () {
       this.getAll()
    },
    methods : {
         getAll() {
          apiGet('procesoItem/byprocess/' + this.procesoId)
            .then(response => (this.items = response.data))
        },        
    }
}

</script>
